<nz-tabs nzSize="large" nzType="card">
    <nz-tab nzTitle="分享页书吧信息配置">
        <app-book-bar-setting></app-book-bar-setting>
    </nz-tab>
    <nz-tab nzTitle="查看报名数据">
        <app-book-bar-enrollment></app-book-bar-enrollment>
    </nz-tab>
</nz-tabs>
